import { useContext } from "react";
import {Container} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "../Footer.module.scss";
import AppConfigContext from "../../context/AppConfigContext";
import { getCurrentYear, getProgramTypeFromSubdomain } from "../../utils/utils";
import { PROGRAM_TYPE } from "../../utils/constants";

const FormFooter = () => {
    const { config } = useContext(AppConfigContext);
    const { t } = useTranslation(config.theme, { keyPrefix: "footer" });
    const { meta, copyright } = config.footer;
    const copyrightText = config.isMultiLingual ? t("copyright", { year: getCurrentYear() }) : copyright;
    // The C-SNP variant carries its own approved material id under "csnp" (PHAR-26).
    const csnp = getProgramTypeFromSubdomain() === PROGRAM_TYPE.CSNP;

    // Prefer translation value for materialId when multilingual; fallback to config.meta
    const materialIdText = config.isMultiLingual
        ? ((csnp ? t(['csnp.materialId', 'materialId']) : t('materialId')) || meta?.materialId)
        : meta?.materialId;

    const consentText = config.isMultiLingual ? t("consentText") : null;

    return (
        <footer className={`py-3 ${styles.footer}`}>
            <Container>
                {consentText && <p className={`small mb-0 lh-base ${styles.textMuted}`}>{consentText}</p>}
                <p className={`small mb-0 lh-base ${styles.textMuted} ${consentText ? 'mt-2' : ''}`}>{copyrightText}</p>
                {materialIdText && <span className={`d-block small ${styles.textMuted} mt-1`}>{materialIdText}</span>}
                {meta?.materialSubtext && <span className={`d-block small ${styles.textMuted} mt-1`}>{meta?.materialSubtext}</span>}
            </Container>
        </footer>
    )
}

export default FormFooter;
